import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
const {sinkEvent} = commons;
import ZpusobPlatbyForm from "../../forms/ZpusobPlatbyForm";
import TablePanel from "../../components/TablePanel";
import ZmenitPoradiModal from "../../components/ZmenitPoradiModal";
import {toastr} from "react-redux-toastr";
import CustomCheckbox from "../../components/CustomCheckbox";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - Forma úhrady
 */
class ZpusobyPlatbyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchZpusobyPlatbyIfNeeded());
    };

    handleCreateZpusobPlatby = () => {
        const {zpusobyPlatbyList, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ZpusobPlatbyForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.createZpusobPlatba(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateZpusobyPlatby());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {poradi: zpusobyPlatbyList.rows.length + 1}
            },
            t('payment_form.new'),
            {size: "md"}
        ));
    };

    handleEditZpusobPlatby = (zpusobPlatby) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ZpusobPlatbyForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.updateZpusobPlatba(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateZpusobyPlatby());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: zpusobPlatby
            },
            t('payment_form.change'),
            {size: "md"}
        ));
    };

    handleZmenitPoradi = () => {
        const {zpusobyPlatbyList, dispatch, t} = this.props;
        if (zpusobyPlatbyList.rows.length !== 0) {
            dispatch(modal.ModalActions.show(
                ZmenitPoradiModal,
                {
                    onOrderChanged: (changedIdsMap) => {
                        CiselnikApi.updatePoradiPlatby(changedIdsMap).then(() => {
                            dispatch(modal.ModalActions.hide());
                            dispatch(ciselnikActions.invalidateZpusobyPlatby());
                        });
                    },
                    items: zpusobyPlatbyList.rows,
                    renderItem: i => {
                        return <CardBody key={i.item.id}>
                            <Row>
                                <Col xs={12}>{i.item.nazevZpusobPlatba}</Col>
                            </Row>
                        </CardBody>;
                    },
                },
                t('change_in_order'),
                {size: "lg", className: "card-form-modal"}
            ));
        } else {
            toastr.warning("Žádné formy úhrady k řazení");
        }
    };

    handleVcetneNeaktivnich = (e) => {
        const {zpusobyPlatbyList} = this.props;
        this.props.dispatch(ciselnikActions.filterZpusobyPlatby({
            ...zpusobyPlatbyList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    renderContextMenu = (zpusobPlatby) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditZpusobPlatby.bind(this, zpusobPlatby))}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {zpusobyPlatbyList, t} = this.props;
        let content;
        if (zpusobyPlatbyList.fetched) {
            if (zpusobyPlatbyList.rows.length !== 0) {
                content = zpusobyPlatbyList.rows.map(zpusobPlatby => {
                    return <CardBody key={zpusobPlatby.id} className={zpusobPlatby.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(zpusobPlatby)} onClick={this.handleEditZpusobPlatby.bind(this, zpusobPlatby)}>
                            <Row>
                                <Col xs={3}>{zpusobPlatby.kodZpusobPlatba}</Col>
                                <Col xs={3}>{zpusobPlatby.nazevZpusobPlatba}</Col>
                                <Col xs={1}>{zpusobPlatby.hotovost ? t('yes') : t('no')}</Col>
                                <Col xs={2}>{zpusobPlatby.povolitBezSpolecnosti ? t('yes') : t('no')}</Col>
                                <Col xs={1}>{!zpusobPlatby.neaktivni ? t('no') : t('yes')}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('payment_form.none')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }
        const vcetneNeaktivnich = zpusobyPlatbyList.filter.vcetneNeaktivnich || false;
        return <AdminPage
            title={t('payment_form.one')}
            subtitle={t('payment_form.system_operator')}
            content={
                <div>
                    <ButtonToolbar>
                        <Button color="primary" onClick={this.handleCreateZpusobPlatby}>{t('new_f')}</Button>
                        <Button color="secondary" onClick={this.handleZmenitPoradi}>{t('change_order')}</Button>
                        <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            <Col xs={3}>{t('labels.code')}</Col>
                            <Col xs={3}>{t('labels.name')}</Col>
                            <Col xs={1}>{t('labels.cash')}</Col>
                            <Col xs={2}>{t('allow_without_company')}</Col>
                            <Col xs={1}>{t('active')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        zpusobyPlatbyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_PLATBY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(ZpusobyPlatbyPage));
